import { Platform } from 'react-native';

import {
  useInitPermissionsMachine,
  usePermissionsMachine,
} from '@sg/shared-fe-features-permissions';

import { useFeatureFlag } from '@order/LaunchDarkly';

// ─────────────────────────────────────────────────────────────────────────────

export const useBackgroundLocationPermissionPrimer = () => {
  const isFeatureEnabled = useFeatureFlag(
    'CELS-5610-order-background-location-permission-primer-enabled',
  );

  // ─── Derived ─────────────────────────────────────────────────────────

  const isBackgroundLocationPrimerEnabled = Platform.OS !== 'web' && isFeatureEnabled;

  // ─── Actor ───────────────────────────────────────────────────────────

  const permissionsActorRef = useInitPermissionsMachine({ isBackgroundLocationPrimerEnabled });

  const {
    isBackgroundLocationPermissionsLoading,
    isBackgroundLocationPrimerVisible,
    isRequestingBackgroundLocationPermission,
    isSkippingBackgroundLocationPermission,
    isBackgroundLocationPermissionApproved,
    isBackgroundLocationPermissionDenied,
    isBackgroundLocationPermissionSkipped,
    isBackgroundLocationPermissionAlreadyShown,
    requestBackgroundLocationPermissions,
    skipBackgroundLocationPermissions,
  } = usePermissionsMachine(permissionsActorRef);

  // ─── Derived ─────────────────────────────────────────────────────────

  const isPrimerActive =
    isBackgroundLocationPrimerVisible ||
    isRequestingBackgroundLocationPermission ||
    isSkippingBackgroundLocationPermission;

  // ─────────────────────────────────────────────────────────────────────

  return {
    isBackgroundLocationPrimerEnabled,
    isBackgroundLocationPermissionsLoading,
    isPrimerActive,
    isRequestingBackgroundLocationPermission,
    isSkippingBackgroundLocationPermission,
    isBackgroundLocationPermissionApproved,
    isBackgroundLocationPermissionDenied,
    isBackgroundLocationPermissionSkipped,
    isBackgroundLocationPermissionAlreadyShown,
    onAllow: requestBackgroundLocationPermissions,
    onSkip: skipBackgroundLocationPermissions,
  };
};
